import { Button, ButtonProps, Drawer, Stack } from '@mui/material'
import React, { useContext } from 'react'
import { useBoolean } from 'react-use'

import { AWSOnboardingForm } from 'components/getting-started/aws/AWSOnboardingForm'
import Icon, { IconName } from 'components/Icon'
import { EditAuthenticationForm } from 'components/status-checks/edit/EditAuthenticationForm'
import { ObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { TeamExternalIntegration } from 'types/api/status-checks/status-check'

export const AWSAccountIdDrawer: React.FC<{
  buttonIcon?: IconName
  buttonProps?: ButtonProps
  buttonText?: string
  externalIntegrations: TeamExternalIntegration[]
  renderButton?: (props: { openDrawer: () => void }) => React.ReactElement
  selectedAWSAccount?: TeamExternalIntegration
}> = ({
  buttonIcon = 'plus',
  buttonText = 'Account ID',
  buttonProps,
  externalIntegrations,
  renderButton,
  selectedAWSAccount
}) => {
  const [isOpen, setIsOpen] = useBoolean(false)

  const { setIsEdit } = useContext(ObservabilityToolAuthenticationContext)

  const isEdit = Boolean(selectedAWSAccount)

  const handleOpen = () => {
    setIsOpen(true)

    if (isEdit) {
      setIsEdit && setIsEdit(true)
    }
  }

  const handleClose = () => {
    setIsOpen(false)
    setIsEdit && setIsEdit(false)
  }

  return (
    <>
      {renderButton ? (
        renderButton({ openDrawer: handleOpen })
      ) : (
        <Button
          size="small"
          startIcon={buttonIcon ? <Icon icon={buttonIcon} /> : null}
          variant="contained"
          onClick={handleOpen}
          {...buttonProps}
        >
          {buttonText}
        </Button>
      )}
      <Drawer
        anchor="right"
        open={isOpen}
        PaperProps={{ sx: { width: 1200 } }}
        onClose={handleClose}
      >
        <Stack p={3}>
          {isEdit ? (
            <EditAuthenticationForm
              authenticationName={selectedAWSAccount?.name}
              domain={selectedAWSAccount?.domain}
              handleCancel={handleClose}
              observabilityToolType={selectedAWSAccount?.observabilityToolType}
            />
          ) : (
            <AWSOnboardingForm
              externalIntegrations={externalIntegrations}
              hasIntroText={false}
              onSuccess={handleClose}
            />
          )}
        </Stack>
      </Drawer>
    </>
  )
}
